export const Action_SaveKho = "Action_SaveKho";
export const Action_SaveKhoSuccess = "Action_SaveKhoSuccess";
export const Action_SaveKhoFailed = "Action_SaveKhoFailed";

export const Action_GetDanhSachKho = "Action_GetDanhSachKho";
export const Action_GetDanhSachKhoSuccess = "Action_GetDanhSachKhoSuccess";

export const Action_GetChiTietKho = "Action_GetChiTietKho";
export const Action_GetChiTietKhoSuccess = "Action_GetChiTietKhoSuccess";

export const Action_DeleteKho = "Action_DeleteKho";
export const Action_DeleteKhoSuccess = "Action_DeleteKhoSuccess";
export const Action_DeleteKhoFailed = "Action_DeleteKhoFailed";

export const Action_LockUnlock = "Action_LockUnlock";
export const Action_LockUnlockSuccess = "Action_LockUnlockSuccess";
export const Action_LockUnlockFailed = "Action_LockUnlockFailed";
